<template>
  <e-chart :option="singleOption" autoresize />
</template>

<script>
import stringUtils from '@/components/mixins/stringUtils'

export default {
  name: 'FractionDisposalPieChart',
  inject: ['companyUser'],
  props: {
    fractionDisposals: {
      type: Object,
      required: true,
    },
    fractionDetails: {
      type: Object,
      required: true,
    },
  },
  mixins: [stringUtils],
  computed: {
    singleOption() {
      const self = this
      const formattedDetails = { clean: [], mixed: [], wrong: [] }

      // this.fractionDetails looks like this:
      //
      // {
      //   clean: {
      //     <fractionUuid>: {
      //       count: 42,
      //       translations: {
      //         de: 'Papier',
      //         en: 'Paper'
      //       }
      //     }
      //     , …
      //   },
      //   mixed: {…},
      //   wrong: {…}
      // }
      for (const [type, details] of Object.entries(this.fractionDetails)) {
        for (const detail of Object.values(details)) {
          const fractionName = detail.translations[self.companyUser.user.language]
          formattedDetails[type].push(`${fractionName}: ${detail.count}`)
        }
      }

      const series = [
        {
          name: this.$t('reporting.industry.fractionDisposals.clean'),
          value: this.fractionDisposals.clean,
          itemStyle: { color: 'green' },
          details: formattedDetails.clean,
        },
        {
          name: this.$t('reporting.industry.fractionDisposals.mixed'),
          value: this.fractionDisposals.mixed,
          itemStyle: { color: 'yellow' },
          details: formattedDetails.mixed,
        },
        {
          name: this.$t('reporting.industry.fractionDisposals.wrong'),
          value: this.fractionDisposals.wrong,
          itemStyle: { color: 'red' },
          details: formattedDetails.wrong,
        },
      ]

      return {
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            return `
              <strong>${params.name}</strong><br/>
              ${params.value} ${self.$t('meta.container')} (${params.percent}%)<br/><br/>

              <strong>${self.$t('meta.fractions')}</strong><br/>
              ${params.data.details.join('<br/>')}
            `
          },
        },
        grid: {
          left: '0',
          right: '0',
          bottom: '0',
          top: '0',
        },
        series: [
          {
            type: 'pie',
            radius: '90%',
            center: ['50%', '50%'],
            data: series,
            label: {
              show: false,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      }
    },
  },
}
</script>
